/* ContentTypeRenderer.js */

"use strict";

class ContentTypeRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("content-type-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    _shutdown() {
        return new Promise((resolve) => {
            this._unregisterListeners();
            this._model = undefined;
            if (this._rootElem) {
                this._rootElem.remove();
            }
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("ValueUpdated", (this._onValueUpdated = this._onValueUpdated.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("ValueUpdated");
    }

    render() {
        return new Promise((resolve) => {
            this._setValueUpdated(this._model.getValue());
            resolve();
        });
    }

    get rootElement() {
        return this._rootElem;
    }

    get model() {
        return this._model;
    }

    _onValueUpdated(newVal) {
        this._setValueUpdated(newVal);
    }

    _setValueUpdated(newVal) {
        const elem = document.createElement("span");

        // Convert contentType to display text
        const displayText = this._model._contentTypeLabels[newVal] || "Unknown";

        elem.innerHTML = displayText;
        elem.title = displayText;
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(elem);
    }
}

module.exports = ContentTypeRenderer;
